import React, { useState, useEffect } from 'react';
import WelcomeWhatsNew from '../Components/Home/WelcomeWhatsNew';
import ImagesRow from '../Components/Home/ImagesRow';
import ContactUs from '../Components/Home/ContactUsForm';
import GoogleMap from '../Components/Home/GoogleMap';
// import { useNavigate, useLocation } from 'react-router-dom';
import { useNavigateAndScroll } from '../Hooks/useNavigateAndScroll';

function Home({ updates }) {
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  // const navigate = useNavigate();
  // const location = useLocation();
  const navigateAndScroll = useNavigateAndScroll();

  // const handleNavigateAndScroll = (pathname, sectionId) => {
  //   if (location.pathname !== pathname) {
  //     navigate(pathname);
  //   }
  //   setTimeout(() => {
  //     const element = document.getElementById(sectionId);
  //     if (element) {
  //       element.scrollIntoView({ behavior: 'smooth' });
  //     }
  //   }, 100);
  // };

  const CIPALocation = { 
    lat: 40.48090976182145,
    lng: -88.94729011428656,
    zoom: 18
  };

  const handleVideoLoaded = () => {
    // console.log('Video loaded successfully');
    setIsVideoLoaded(true);
  };

  useEffect(() => {
    const videoElement = document.getElementById('homepage-video');
    if (videoElement) {
      const events = ['loadeddata', 'canplay', 'canplaythrough'];
      const handleEvent = (event) => {
        // console.log(`Video event triggered: ${event.type}`);
        handleVideoLoaded();
      };
      events.forEach(event => {
        videoElement.addEventListener(event, handleEvent);
      });

      const fallbackTimer = setTimeout(() => {
        // console.log('Fallback: Attempting to play video');
        videoElement.play().then(() => {
          // console.log('Fallback: Video started playing');
          handleVideoLoaded();
        }).catch(error => {
          console.error('Fallback: Error playing video', error);
        });
      }, 3000);

      return () => {
        events.forEach(event => {
          videoElement.removeEventListener(event, handleEvent);
        });
        clearTimeout(fallbackTimer);
      };
    }
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <div className="hidden tablet:block laptop:block relative w-full overflow-hidden" style={{ marginTop: '-125px' }}>
        <div className="relative pt-[44.26%]">
          <img 
            className={`absolute top-0 left-0 w-full h-full object-cover smartphone:hidden ${isVideoLoaded ? 'hidden' : 'block'}`}
            src="https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/Home+Page+(1).webp" 
            alt="Panorama of children of various ages"
          />
          <video
            id="homepage-video"
            className={`absolute top-0 left-0 w-full h-full object-cover smartphone:hidden ${isVideoLoaded ? 'block' : 'hidden'}`}
            src="https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/Slide+show+second+version.webm"
            autoPlay
            loop
            muted
            playsInline
          />
          <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 smartphone:hidden">
            <button 
              className="text-white font-bold bg-custom-regularOrange px-2 py-1 rounded-md hover:bg-custom-darkOrange"
              onClick={() => navigateAndScroll('/patient-center/new-patient')}
            >
              New to our practice - LET US HELP YOU
            </button>
          </div>
        </div>
      </div>

      {/* Added top padding so that content appears below the header */}
      <div className="flex-grow">
        <div className="w-full px-2 my-4">
          <WelcomeWhatsNew updates={updates} />
        </div>
        <ImagesRow />
        <ContactUs />
        <GoogleMap lat={CIPALocation.lat} lng={CIPALocation.lng} zoom={CIPALocation.zoom} />
      </div>
    </div>
  );
}

export default Home;
